import {ErrorHandler, isDevMode, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from "@angular/forms";
import { HttpClient } from "@angular/common/http";

import {TranslateLoader, TranslateModule} from '@ngx-translate/core';

import {SharedModule} from "@shared/shared.module";
import {AppErrorHandler} from "@shared/error-handler";
import {DialogService} from "@shared/services/dialog.service";
import {ShowTimeoutModalService} from "@shared/services/show-timeout-modal.service";
import {ShowErrorModalService} from "@shared/services/show-error-modal.service";

import {AuthenticationRoutesModule} from './authentication-routes.module/authentication-routes.module';

import {
  CreateAccountConfirmationComponent
} from './routes/create-account-confirmation/create-account-confirmation.component';
import {LoginComponent} from './routes/login/login.component';
import {LoginFooterComponent} from './components/login-footer/login-footer.component';
import {SelectDatabaseComponent} from './routes/select-database/select-database.component';
import {CreateAccountComponent} from './routes/create-account/create-account.component';
import {ResetPasswordComponent} from './routes/reset-password/reset-password.component';
import {
  ResetPasswordConfirmationComponent
} from './routes/reset-password-confirmation/reset-password-confirmation.component';
import {WelcomeComponent} from './routes/welcome/welcome.component';
import {SetNewPasswordComponent} from './routes/set-new-password/set-new-password.component';
import {
  SetNewPasswordConfirmationComponent
} from './routes/set-new-password-confirmation/set-new-password-confirmation.component';
import {HttpProgressInterceptor} from "@commons/services/http.interceptor/http-progress-interceptor.service";
import {LogoutComponent} from './routes/logout/logout.component';

import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {LinkLoginComponent} from "@authentication/routes/link-login/link-login.component";
import { HandoverLoginComponent } from '@authentication/routes/handover-login/handover-login.component';
import { LottieComponent } from 'ngx-lottie';

// AoT requires an exported function for factories
// export function AuthenticationHttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http, './assets/i18n/', '.json');//'./assets/i18n/authentication/'
// }

@NgModule({
  declarations: [
    WelcomeComponent,
    LoginComponent,
    LoginFooterComponent,
    SelectDatabaseComponent,
    CreateAccountComponent,
    ResetPasswordComponent,
    ResetPasswordConfirmationComponent,
    CreateAccountConfirmationComponent,
    SetNewPasswordComponent,
    SetNewPasswordConfirmationComponent,
    LogoutComponent,
    LinkLoginComponent,
    HandoverLoginComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthenticationRoutesModule,
    SharedModule,
    TranslateModule,
    LottieComponent,
    // TranslateModule.forChild({
    //   defaultLanguage: 'pl-PL',
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: AuthenticationHttpLoaderFactory,
    //     deps: [HttpClient]
    //   }
    // }),
  ],
  providers: [
    {provide: ErrorHandler, useClass: AppErrorHandler},
  ]
})
export class AuthenticationModule {

  constructor(
    private dialogService: DialogService,
    private showTimeoutModalService: ShowTimeoutModalService,
    private showErrorModalService: ShowErrorModalService
  ) {

    if (isDevMode())
      console.log('AuthenticationModule loaded');

    this.subscribeToError();
    this.subscribeToHttpProgressInterceptorEvents();
  }

  private subscribeToError() {
    AppErrorHandler.$onError.subscribe(error => this.showErrorModalService.showModal(error));
  }

  private subscribeToHttpProgressInterceptorEvents() {
    HttpProgressInterceptor.$errorSubject.subscribe(() => this.showTimeoutModalService.showModal());
    HttpProgressInterceptor.$timeoutSubject.subscribe(() => this.showTimeoutModalService.showModal());
  }
}
